import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LANGUAGES } from '@modeso/aumico-lib-core-fe';
import { localizationKeys } from '../../constants/localizationKeys';
import { IPersonalInformation } from '../../interfaces/personal-information.interface';

@Component({
    selector: 'aumico-accept-invitation',
    templateUrl: './accept-invitation.page.html',
    styleUrls: ['./accept-invitation.page.scss'],
})
export class AcceptInvitationPage {
    isPersonalInformationFormValid = false;
    personalInformationFormValue: IPersonalInformation | undefined;
    backendError = false;
    isCreateAccountButtonClicked = false;
    localizations = localizationKeys;
    userEmailAlreadyExist: boolean;
    @Input() supportedLocales: string[] = [];
    @Input() defaultLanguage = LANGUAGES.ENGLISH;
    @Input() organization: string;
    @Output() emitPersonalMetaInformation = new EventEmitter<Omit<IPersonalInformation, 'organizationName'>>();
    constructor(private readonly domSanitizer: DomSanitizer, private readonly matIconRegistry: MatIconRegistry) {
        this.addSvgIcon('aumico-pattern-icon-loading');
    }

    onPersonalInformationFormStatusChange(personalInformationFormStatus: boolean): void {
        this.isPersonalInformationFormValid = personalInformationFormStatus;
    }

    onPersonalInformationFormValueChange(personalInformationFormValue: IPersonalInformation): void {
        this.personalInformationFormValue = personalInformationFormValue;
    }
    showPasswordForm(): void {
        const { firstName, lastName, locale, organizationName } = this.personalInformationFormValue;
        const personalInformationData: IPersonalInformation = {
            firstName,
            lastName,
            locale,
            organizationName,
        };
        this.isCreateAccountButtonClicked = true;
        this.emitPersonalMetaInformation.emit(personalInformationData);
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
